export const languageMapping = (language) => {
  switch (language) {
    case "zh_chs":
      return "简体";
    case "en":
      return "English";
    case "tw":
      return "繁體";
    // case "tag":
    //   return "Tagalog";
    case "viet":
      return "Tiếng Việt";
  }
};

export const LANGUAGES = [
  {
    text: "English",
    language: "en",
    value: "en",
    flag: "US",
    semantic_flag: "us",
  },
  {
    text: "简体",
    language: "zh_chs",
    value: "zh_chs",
    flag: "CN",
    semantic_flag: "cn",
  },
  {
    text: "繁體",
    language: "tw",
    value: "tw",
    flag: "TW",
    semantic_flag: "tw",
  },
  // {
  //   text: "Tagalog",
  //   language: "tag",
  //   value: "tag",
  //   flag: "PH",
  //   semantic_flag: "ph",
  // },
  {
    text: "Tiếng Việt",
    language: "viet",
    value: "viet",
    flag: "vn",
    semantic_flag: "vn",
  },
];
export const LANGUAGES_MENU = [
  {
    text: "English",
    language: "en",
    value: "en",
    flag: "us",
  },
  {
    text: "简体",
    language: "zh_chs",
    value: "zh_chs",
    flag: "cn",
  },
  {
    text: "繁體",
    language: "tw",
    value: "tw",
    flag: "tw",
  },
  // {
  //   text: "Tagalog",
  //   language: "tag",
  //   value: "tag",
  //   flag: "ph",
  // },
  {
    text: "Tiếng Việt",
    language: "viet",
    value: "viet",
    flag: "vn",
  },
];
